<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-row>
            <b-col cols="12" lg="5">
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectClient"
                />
            </b-col>
            <b-col cols="12" lg="5">
                <b-button-group>
                    <b-button
                        v-for="status in petitionStatuses"
                        :title="status.description"
                        @click="filterByStatus(status.id)"
                        :key="status.id"
                        :variant="
                            status.id === filters.status
                                ? 'success'
                                : 'secondary'
                        "
                        >{{ status.name }}</b-button
                    >
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4" lg="2">
                <app-form-text-input
                    placeholder="Usuario creador"
                    v-model="filters.creatoruser"
                ></app-form-text-input>
            </b-col>
            <b-col
                cols="12"
                md="4"
                lg="2"
                v-if="filters.slugstatus !== 'recibida'"
            >
                <app-form-text-input
                    placeholder="Usuario responsable"
                    v-model="filters.assigned"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="4" lg="2">
                <app-form-select-input
                    placeholder="Tipo"
                    :options="types"
                    v-model="filters.type"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="2">
                <app-form-select-input
                    placeholder="Categoria"
                    :options="categories"
                    v-model="filters.category"
                    @change="onSelectCategory"
                >
                </app-form-select-input>
            </b-col>
            <b-col cols="12" lg="2">
                <app-form-select-input
                    placeholder="SubCategoria"
                    :options="subCategories"
                    v-model="filters.subCategory"
                >
                </app-form-select-input>
            </b-col>
            <b-col>
                <app-form-select-input
                    placeholder="Satisfacción"
                    :options="satisfactionOptions"
                    v-model="filters.satisfaction"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="2">
                <app-form-select-input
                    placeholder="Calificación"
                    :options="ratings"
                    v-model="filters.rating"
                ></app-form-select-input>
            </b-col>
        </b-row>
        <b-row align-v="end">
            <b-col cols="12" lg="5" v-if="filters.slugstatus !== 'recibida'">
                <b-row>
                    <b-col cols="12">
                        <app-sub-title text="Rango de fechas"></app-sub-title>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col cols="12" md="5">
                        <b-form-input
                            type="date"
                            id="dateFrom"
                            placeholder="Desde"
                            v-model="filters.dateFrom"
                        />
                    </b-col>
                    <b-col cols="12" md="5">
                        <b-form-input
                            type="date"
                            id="dateTo"
                            placeholder="Hasta"
                            v-model="filters.dateTo"
                        />
                    </b-col>
                    <b-col>
                        <b-form-radio-group v-model="filters.dateType">
                            <b-form-radio value="assignation"
                                >Asignación</b-form-radio
                            >
                            <b-form-radio value="expiration"
                                >Vencimiento</b-form-radio
                            >
                        </b-form-radio-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="5" v-else>&nbsp;</b-col>

            <b-col
                cols="12"
                lg="5"
                v-if="
                    filters.slugstatus === 'resuelta' || filters.approved === 1
                "
            >
                <b-row>
                    <b-col cols="12">
                        <app-sub-title
                            text="Fecha de Resolución"
                        ></app-sub-title>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="6">
                        <b-form-input
                            type="date"
                            id="answerDateFrom"
                            placeholder="Desde"
                            v-model="filters.answerDateFrom"
                            :with-time="false"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-input
                            type="date"
                            id="answerDateTo"
                            placeholder="Hasta"
                            v-model="filters.answerDateTo"
                            :with-time="false"
                        />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="5" v-else>&nbsp;</b-col>
            <b-col cols="12" lg="2">
                <b-row>
                    <b-col cols="12" lg="6">
                        <b-button
                            variant="primary"
                            class="btn-block"
                            @click="$emit('filter', filters)"
                            ><i class="fa fa-filter"></i
                        ></b-button>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-button
                            variant="secondary"
                            class="btn-block"
                            @click="clearFilters"
                            ><i class="fa fa-times-circle"></i
                        ></b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue'
import DateTimePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue'

export default {
    components: {
        // appAutocomplete: Autocomplete,
        appDateTimePicker: DateTimePicker,
    },
    props: {
        isAssigned: {
            type: Boolean,
            default: false,
        },
        isResolved: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filters: {
                assigned: '',
                dateFrom: '',
                dateTo: '',
                answerDateFrom: '',
                answerDateTo: '',
                client: '',
                status: '',
                approved: '',
                creatoruser: '',
                type: '',
                category: '',
                subCategory: '',
                dateType: 'assignation',
                satisfaction: '',
                rating: '',
            },
            selectClient: '',
            types: [],
            categories: [],
            subCategories: [],
            ratings: [],
            satisfactionOptions,
        }
    },
    computed: {
        ...mapGetters(['clients', 'petitionStatuses']),
    },
    watch: {
        selectClient(val) {
            if (!val) {
                this.filters.client = ''
                this.selectClient = ''
            } else {
                this.filters.client = val.id
            }
        },
    },
    methods: {
        clearFilters() {
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.filters.dateType = 'assignation'
            this.$emit('filter', null)
        },
        filterByStatus(statusId) {
            this.filters.status = statusId
            this.$emit('filter', this.filters)
        },
        async loadPetitionTypes() {
            const { data } = await repo.get(
                'petitions/types',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.types = data
        },
        async loadPetitionCategories() {
            const { data } = await repo.get(
                'petitions/categories',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.categories = data
        },
        async loadPetitionRatings() {
            const { data } = await repo.get(
                'petitions/ratings',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.ratings = data
        },
        async onSelectCategory() {
            if (this.filters.category !== '') {
                const { data } = await repo.get(
                    'petitions/sub-categories',
                    { category: this.filters.category },
                    'Lo sentimos, ha ocurrido un error'
                )
                this.subCategories = data
                if (data.length === 1) {
                    this.filters.subCategory = data[0].id
                }
            }
        },
    },
    created() {
        this.load('clients')
        this.load('petitionStatuses')
        this.loadPetitionTypes()
        this.loadPetitionCategories()
        this.loadPetitionRatings()
    },
}

const satisfactionOptions = [
    { id: 4, name: '😍 Muy satisfecho' },
    { id: 3, name: '🙂 Satisfecho' },
    { id: 2, name: '😞 Insatisfecho' },
    { id: 1, name: '😡 Muy insatisfecho' },
]
</script>
